// Core
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

// Modules
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { environment } from './../environments/environment';
import { FormsModule } from '@angular/forms';
import { MatchesSubCatPipe } from './filter-prod.pipe';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RoutingModule } from './app-routing.module';

// Components
import { AboutUsComponent } from './components/about-us/about-us.component';
import { AppComponent } from './app.component';
import { ClientCarouselComponent } from './components/client-carousel/client-carousel.component';
import { CateogrySidebarComponent } from './shop/category-sidebar/category-sidebar.component';
import { FaqComponent } from './components/faq/faq.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeCarouselComponent } from './components/home-carousel/home-carousel.component';
import { HomeComponent } from './components/home/home.component';
import { LogoComponent } from './components/logo/logo.component';
import { NavComponent } from './components/nav/nav.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { SearchComponent } from './shop/search/search.component';

// Shop
import { CartMenuComponent } from './shop/cart-menu/cart-menu.component';
import { CategoryChildComponent } from './shop/category-child/category-child.component';
import { CheckoutComponent } from './shop/checkout/checkout.component';
import { ProductSelectorComponent } from './shop/search/product-selector/product-selector.component';
import { ProductListComponent } from './shop/search/product-list/product-list.component';
import { SingleProductComponent } from './shop/single-product/single-product.component';
import { SubscriptionMenuComponent } from './shop/subscription-menu/subscription-menu.component';
import { ViewAllComponent } from './shop/view-all/view-all.component';
import { WelcomeIntroComponent } from './components/welcome-intro/welcome-intro.component';
import { SafePipe } from './shop/pipes/safe.pipe';
import { AcceptComponent } from './shop/sagepay/accept/accept.component';
import { DeclineComponent } from './shop/sagepay/decline/decline.component';
import { NotifyComponent } from './shop/sagepay/notify/notify.component';
import { RedirectComponent } from './shop/sagepay/redirect/redirect.component';

@NgModule({
  bootstrap: [
    AppComponent
  ],
  declarations: [
    AboutUsComponent,
    AppComponent,
    CartMenuComponent,
    CategoryChildComponent,
    CateogrySidebarComponent,
    CheckoutComponent,
    ClientCarouselComponent,
    FaqComponent,
    FooterComponent,
    HeaderComponent,
    HomeCarouselComponent,
    HomeComponent,
    LogoComponent,
    MatchesSubCatPipe,
    NavComponent,
    NotFoundComponent,
    ProductSelectorComponent,
    ProductListComponent,
    SearchComponent,
    SingleProductComponent,
    SubscriptionMenuComponent,
    ViewAllComponent,
    WelcomeIntroComponent,
    SafePipe,
    AcceptComponent,
    DeclineComponent,
    NotifyComponent,
    RedirectComponent
  ],
  imports: [
    BrowserModule,
    NgbModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    FormsModule,
    HttpClientModule,
    RoutingModule
  ]
})
export class AppModule {}
